export interface IOrderSubStatusSchema {
    failReasons?: string[];
    successReasons?: string[];
}
